import { render, staticRenderFns } from "./LayoutPlaceholder.vue?vue&type=template&id=4f5d1248&lang=pug&"
import script from "./LayoutPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./LayoutPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports